import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import EmergencyContactList from './EmergencyContactList'

const EmergencyContactForm = ({ item, categoryHandler, allLevelHandler, individualLevelHandler, isNotifFormEnabled }) => {
    const [selectAllCheckBox, setselectAllCheckBox] = useState(false)
    const [levelListArr, setLevelListArr] = useState([])

    useEffect(() => {
        setselectAllCheckBox(item?.ContactLevel?.every(i => i.contactSelected))
    }, [item])

    const individualCheck = (id) => {
        const temArr = levelListArr.map((item) => {
            let obj;
            if (item.id == id) {
                obj = {
                    ...item,
                    isChecked: !item.isChecked
                }
            } else {
                obj = {
                    ...item,
                }
            }
            return obj;
        })
        setLevelListArr(temArr)
    }

    return (
        <tr>
            <td style={{ width: "5%" }}>
                <Form.Check type='checkbox' aria-label="option 1"
                    checked={item.CategorySelected}
                    onChange={() => categoryHandler(item.Category)}
                    disabled={!isNotifFormEnabled}
                />
            </td>
            <td>
                <div className="inputTypeLabelContainer removeBorder">
                    <input className="inputType" readOnly
                        value={item.Category}
                    />
                </div>
            </td>
            <td>
                <div className="filterBoxhgt" style={{ height: "105px" }}>
                    <div className="dataAccessListItem mt-2">
                        <input type="checkbox"
                            disabled={!isNotifFormEnabled}
                            checked={selectAllCheckBox}
                            onChange={() => {
                                setselectAllCheckBox(!selectAllCheckBox)
                                allLevelHandler(item.Category, !selectAllCheckBox)
                            }}
                        />
                        <p className="AllTextwithValue mb-1" style={{ fontWeight: "500" }}
                        // onClick={() => {setselectAllCheckBox(!selectAllCheckBox);
                        //      allLevelHandler(item.Category, !selectAllCheckBox)}}
                        >Select all <span>{item.ContactLevel.length}</span>
                        </p>
                    </div>
                    <div className="HgtFilterBoxList" style={{ height: "80px" }}>
                        {
                            item.ContactLevel.map((i) => (
                                <EmergencyContactList
                                    key={i.contactId}
                                    item={i}
                                    individualCheck={individualCheck}
                                    parentObj={item.Category}
                                    individualLevelHandler={individualLevelHandler}
                                    isNotifFormEnabled={isNotifFormEnabled}
                                />
                            ))
                        }
                    </div>
                </div>
            </td>
        </tr>
    )
}
export default EmergencyContactForm